import { useLayoutEffect } from "react";

/**
 * Keeps an absolutely positioned popup inside the viewport (Kuest's collisionPadding):
 * after it opens, nudge it sideways if it would overflow either edge.
 * `align` is "end" (anchored with right: 0) or "start" (left: 0).
 */
export default function useCollision(panelRef, open, align, padding = 16) {
  useLayoutEffect(() => {
    const panel = panelRef.current;
    if (!open || !panel) return;
    panel.style.left = "";
    panel.style.right = "";
    // Layout box (ignores the open animation's scale transform).
    const parent = panel.offsetParent;
    const base = parent ? parent.getBoundingClientRect().left : 0;
    const left = base + panel.offsetLeft;
    const rect = { left, right: left + panel.offsetWidth };
    const vw = window.innerWidth || document.documentElement.clientWidth;
    let delta = 0;
    if (rect.left < padding) delta = padding - rect.left;
    else if (rect.right > vw - padding) delta = vw - padding - rect.right;
    if (!delta) return;
    if (align === "end") panel.style.right = `${-delta}px`;
    else panel.style.left = `${delta}px`;
  });
}
